/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/316-arrow-up-right2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.707 13.707L12 5.414V9a1 1 0 002 0V3a1.002 1.002 0 00-1-1v-.001H7a1 1 0 000 2h3.586l-8.293 8.293a.997.997 0 000 1.414.999.999 0 001.414 0z"/>'
  }
})
